import styled from "styled-components"
import {rgba} from "polished"

interface ContainerProps {
  isMenuDisplayed: boolean
}

export const NotificationContainer = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  height: 35px;
  padding: ${({theme}) => `${theme.spacing.one}`};
  cursor: pointer;
  border-radius: ${({theme}) => `${theme.spacing.five}`};
  margin-left: ${({theme}) => `${theme.spacing.one}`};
  right: ${({theme}) => `${theme.spacing.one}`};

  ${({isMenuDisplayed, theme}) => !isMenuDisplayed && `
    &:hover {
      background-color: ${rgba(theme.colors.primary1_50, 0.35)}
    }
  `}

  ${({isMenuDisplayed, theme}) => isMenuDisplayed && `
    background-color: ${theme.colors.primary1_50};
  `}
`
export const NotificationCount = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  background-color: ${({theme}) => `${theme.colors.error}`};
  border-radius: ${({theme}) => `${theme.spacing.five}`};
  color: ${({theme}) => `${theme.colors.greys.white}`};
  width: ${({theme}) => `${theme.spacing.three}`};
  height: ${({theme}) => `${theme.spacing.three}`};
  margin-bottom: ${({theme}) => `${theme.spacing.oneAndHalf}`};
  margin-left: ${({theme}) => `${theme.spacing.oneAndHalf}`};
`
